export enum UploadType {
  LOGO = 'LOGO',
  ITEM = 'ITEM',
  VENUE = 'VENUE',
}
